'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// This file defines a React component that easily displays a video player using
// data stored on DatoCMS and retrieved via DatoCMS GraphQL API. The component
// is a thin wrapper around the [React component made available by MUX][1].
//
// The React player written by MUX is an adapter for a web component.
//
// [1]: https://www.mux.com/player
import React, { forwardRef } from 'react';
// React MUX player is made available in two flavours: eager and lazy loaded. We
// choose to use the lazy version to avoid loading the web component uselessly.
// MUX player lazy version loads internally the eager version using
// `React.lazy()`.
import MuxPlayer from '@mux/mux-player-react/lazy';
// The core of this component is the `useVideoPlayer` hook: it takes
// data from DatoCMS GraphQL API and returns props as expected by the
// `<MuxPlayer />` component.
import { useVideoPlayer } from '../useVideoPlayer/index.js';
export const VideoPlayer = forwardRef((props, ref) => {
    const { data = {}, disableCookies = true, disableTracking = true, preload = 'metadata', style: styleFromProps } = props, rest = __rest(props, ["data", "disableCookies", "disableTracking", "preload", "style"]);
    const { title, playbackId, style: styleFromHook, placeholder, } = useVideoPlayer({
        data,
    });
    const style = Object.assign(Object.assign({}, styleFromHook), styleFromProps);
    return (React.createElement(MuxPlayer, Object.assign({ ref: ref, streamType: "on-demand", preload: preload, title: title, disableCookies: disableCookies, disableTracking: disableTracking, playbackId: playbackId, style: style, placeholder: placeholder }, rest)));
});
//# sourceMappingURL=index.js.map